import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import { CMTS_API } from "../api/cmtsApiPaths.js";
import { repositoryCall } from "./repositoryResult.js";

export function createAccessRepository(client: CmtsHttpClient) {
  return {
    effective: (tenantId?: string) => repositoryCall(() => client.get<unknown>(CMTS_API.access.effective, { query: { tenantId } }), "CMTS_ACCESS_EFFECTIVE"),
    userPermissions: (userId: string, tenantId?: string) => repositoryCall(() => client.get<readonly string[]>(CMTS_API.access.userPermissions(userId), { query: { tenantId } }), "CMTS_ACCESS_USER_PERMISSIONS"),
  };
}
